// extracted by mini-css-extract-plugin
module.exports = {"actionWidget":"ActionWidget_actionWidget__99n6l","actionWidget_icon":"ActionWidget_actionWidget_icon__2XZy1","actionWidget_name":"ActionWidget_actionWidget_name__18LBY"};